import { useEffect, memo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { SearchField, useFormField } from '@frontend/design-system';
import { useInsuranceReportShallowStore } from '../../stores/use-insurance-report-store';
import { getDefaultSearchValue } from '../../utils/utils';

type SearchProps = {
  onSearchChange: (value: string) => void;
};

const Search = memo(({ onSearchChange }: SearchProps) => {
  const { insuranceReportModalState } = useInsuranceReportShallowStore('insuranceReportModalState');
  const searchableField = useFormField({
    type: 'text',
    value: getDefaultSearchValue(insuranceReportModalState.searchValue),
  });
  const { t } = useTranslation();

  useEffect(() => {
    onSearchChange(searchableField.value.toLowerCase());
  }, [searchableField.value]);

  return (
    <SearchField
      data-tracking-id='wie-insurance-report-table-search'
      {...searchableField}
      placeholder={t('Eg: D0801, Family')}
      css={{ width: theme.spacing(40) }}
      name={'InsuranceReportTableSearch'}
    />
  );
});

Search.displayName = 'Search';

export default Search;
